// src/pages/Partners.js — RGA Partners: the people table locked to RGA
// Partners, with the partner columns and filters.
import PeopleTable from '../components/people/PeopleTable'

export default function Partners() {
  return <PeopleTable view="partners" profileBase="/rga-partners" />
}
